import { SET_ACCOUNT_INFO } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').Subscriptions} Subscriptions
 */

/**
 * @typedef {ReturnType<typeof setAccountInfo>} AccountActions
 */

/**
 * @param {Subscriptions} info
 * @return {{ type: 'SET_ACCOUNT_INFO', info: Subscriptions }}
 */
export const setAccountInfo = (info) => ({
  type: SET_ACCOUNT_INFO,
  info,
})
